import React, { useEffect } from "react";
import DefaultCurrencyFormat from "../../DefaultCurrencyFormat";
import { useTranslation } from "../../../context/TranslationContext";
import { useFormikContext } from "formik";

const Installement = ({ handleChange, installement, paymentDetails }) => {
  const formik = useFormikContext();
  const { installementFull, installement: installementText } = useTranslation();
  useEffect(() => {
    if (installement.length <= 1) {
      formik.setFieldValue("installement", 1);
    }
  }, [installement]);
  return (
    <select
      name="installement"
      onChange={handleChange}
      className={
        "mt-6 bg-gray-50 border outline-none focus:border-brand-color-secondary border-gray-300 text-gray-900 text-sm rounded-lg   w-full p-2.5 transform-gpu transition-all origin-top  " +
        (installement.length > 1 ? "scale-y-1 " : "scale-y-0 hidden")
      }
    >
      {installement.map((e, l) => (
        <option value={e.installmentNumber} key={"installement_" + l}>
          {e.installmentNumber == "1" || e.installmentNumber == "0" ? (
            installementFull
          ) : (
            <>
              {e.installmentNumber} {installementText} x{" "}
              <DefaultCurrencyFormat
                Symbol={paymentDetails.Symbol}
                value={e.installmentPrice}
                decimalScale={2}
              />{" "}
              ={" "}
              <DefaultCurrencyFormat
                Symbol={paymentDetails.Symbol}
                value={e.totalPrice}
                decimalScale={2}
              />
            </>
          )}
        </option>
      ))}
    </select>
  );
};

export default Installement;
